<template>
    <fragment>
        <h2>{{ title }}</h2>
        <p v-if="description">{{ description }}</p>
    </fragment>
</template>

<script>
export default {
    name: "FormSectionTitle",
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false,
            default: undefined
        }
    }
};
</script>

<style scoped lang="scss">
h2 {
    margin: 35px 0 0 0;
    font-family: "Roboto", sans-serif;
    font-weight: 100;
    font-style: italic;
    font-size: 25px;
}
p {
    margin: 0 0 15px 0;
    font-style: italic;
}
</style>



// WEBPACK FOOTER //
// FormSectionTitle.vue?4579b517